import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { environment } from './../../environments/environment';
import { SpinnerService as Spinner } from '../shared/components/spinner/spinner.service';

@Injectable({
  providedIn: 'root',
})
export class ForgotPasswordService {
  private baseUrl = `${environment.apiUrl}/password`;

  constructor(private http: HttpClient, private spinner: Spinner) {}

  sendRecoveryEmail(email: string): Observable<{ message: string }> {
    this.spinner.open({
      title: 'Enviando correo',
      message: 'Estamos enviando el código de recuperación.',
    });

    return this.http
      .post<{ message: string }>(`${this.baseUrl}/forgot`, { email })
      .pipe(
        finalize(() => {
          this.spinner.close();
        })
      );
  }

  validateCode(email: string, code: string): Observable<{ valid: boolean; message: string }> {
    this.spinner.open({
      title: 'Validando código',
      message: 'Estamos validando el código ingresado.',
    });

    return this.http
      .post<{ valid: boolean; message: string }>(
        `${this.baseUrl}/validate-code`,
        { email, code }
      )
      .pipe(
        finalize(() => {
          this.spinner.close();
        })
      );
  }

  resetPassword(payload: {
    email: string;
    code: string;
    password: string;
    password_confirmation: string;
  }): Observable<{ message: string }> {
    this.spinner.open({
      title: 'Actualizando contraseña',
      message: 'Por favor, esperá mientras actualizamos tu contraseña.',
    });

    return this.http
      .post<{ message: string }>(`${this.baseUrl}/reset`, payload)
      .pipe(
        finalize(() => {
          this.spinner.close();
        })
      );
  }
}
